import { sendIt } from 'gatsby-plugin-purina-analytics/common/functions';
import React from 'react';

import { NerdMenuElementType } from 'src/common/enums';
import { getAnchorTarget } from 'src/utils/url';
import { BaseLink } from '../Link';

const NerdMenuLinkListWrapper: React.FC<{
  linkListWrapper: NerdMenuElement;
}> = ({ linkListWrapper }) => {
  const onlyHasComponents = linkListWrapper.menuElements?.every(
    element => element.type === NerdMenuElementType.COMPONENT,
  );

  // TODO: Remove when enabling components
  if (onlyHasComponents) {
    return null;
  }

  return (
    <div className="pds-flex pds-flex-col pds-gap-4.5 pds-rounded pds-bg-surface-layer pds-p-4 lg:pds-gap-4">
      {linkListWrapper.menuElements?.map(element => {
        // LinkList
        if (element.type === NerdMenuElementType.LINK_LIST_HEADING) {
          return (
            <div className="pds-flex pds-flex-col pds-gap-3.5" key={element.title}>
              <h3 className="pds-text-body-md pds-font-extrabold">{element.title}</h3>

              <ul className="p-0 m-0 pds-flex pds-flex-col lg:pds-gap-3">
                {element.menuElements?.map(link => {
                  return (
                    <li key={link.title}>
                      <BaseLink
                        partiallyActive
                        analytics={false}
                        to={link.link.url}
                        target={getAnchorTarget(link.link.url)}
                        className="pds-flex pds-max-w-[max-content] pds-items-center pds-gap-3 pds-py-3.5 pds-text-body-md pds-text-black pds-no-underline focus-visible:pds-rounded-sm focus-visible:pds-outline focus-visible:pds-outline-2 focus-visible:pds-outline-offset-2 focus-visible:pds-outline-focus lg:pds-py-0"
                        onClick={() => {
                          sendIt({
                            event: 'nav_click',
                            eventParams: {
                              nav_item: element.title,
                              nav_type: 'header',
                            },
                          });
                        }}
                      >
                        {link.title}
                      </BaseLink>
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        }

        // Bold link
        if (element.type === NerdMenuElementType.BOLD) {
          return (
            <BaseLink
              partiallyActive
              analytics={false}
              key={element.title}
              to={element.link.url}
              target={getAnchorTarget(element.link.url)}
              className="pds-flex pds-max-w-[max-content] pds-items-center pds-gap-3 pds-py-3.5 pds-text-body-md pds-font-extrabold pds-text-black pds-no-underline focus-visible:pds-rounded-sm focus-visible:pds-outline focus-visible:pds-outline-2 focus-visible:pds-outline-offset-2 focus-visible:pds-outline-focus lg:pds-py-0"
              onClick={() => {
                sendIt({
                  event: 'nav_click',
                  eventParams: {
                    nav_item: element.title,
                    nav_type: 'header',
                  },
                });
              }}
            >
              {element.title}
            </BaseLink>
          );
        }

        // TODO: Maybe inject the components here?

        // eslint-disable-next-line no-console
        console.warn('Unknown element type in link list wrapper', element);
        return null;
      })}
    </div>
  );
};

export default NerdMenuLinkListWrapper;
